// Date/time formatting helpers using dayjs (TypeScript)
// Formats:
// - Date: DD-MM-YYYY
// - Date time: DD-MM-YYYY hh:mm A

import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'

export type DateInput = string | number | Date | Dayjs | null | undefined

const formatLocalDate = (value: DateInput, format: string): string => {
  if (!value) return '-'
  const d = dayjs.utc(value)
  return !d.isValid() ? '-' : d.local().format(format)
}

/**
 * Format a value (UTC) into local date string: DD-MM-YYYY
 */
export const localDate = (value: DateInput): string =>
  formatLocalDate(value, 'DD-MM-YYYY')

/**
 * Format a value (UTC) into local date time string: DD-MM-YYYY hh:mm A
 */
export const localDateTime = (value: DateInput): string =>
  formatLocalDate(value, 'DD-MM-YYYY hh:mm A')
